module.exports = __webpack_public_path__ + "static/media/fireplace3.6b6434ab.png";